module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentFluxer[0]) ? _c('div', {
    staticClass: "reporte-objetivos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Reportes de Objetivos"
    }
  }), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("Dueño")]), _vm._v(" "), _c('md-table-head', [_vm._v("Lider")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de creacion")]), _vm._v(" "), _c('md-table-head', [_vm._v("Acuerdo vigente")]), _vm._v(" "), _c('md-table-head', [_vm._v("Acuerdo finalizado")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.allAcuerdos), function(acuerdo, index) {
    return _c('md-table-row', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(acuerdo)
        }
      }
    }, [_c('md-table-cell', [_vm._v(_vm._s(acuerdo.owner))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(acuerdo.editor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.created, "YYYY/MM/DD HH:mm")))]), _vm._v(" "), (acuerdo.sent) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.sent, "YYYY/MM/DD HH:mm")))]) : _c('md-table-cell', [_vm._v("-")]), _vm._v(" "), (acuerdo.finalizado) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(acuerdo.finalizado, "YYYY/MM/DD HH:mm")))]) : _c('md-table-cell', [_vm._v("-")])], 1)
  }))], 1) : _vm._e()], 1) : _c('div', [_vm._v("\n      Necesita ser Administrador de la app para ver esta seccion\n  ")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46abe750"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReporteObjetivos.vue
// module id = 377
// module chunks = 1